import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFullscreen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.916748 15.0833V11.157H2.16675V13.8333H4.843V15.0833H0.916748ZM11.1651 15.0833V13.8333H13.8413V11.157H15.0913V15.0833H11.1651ZM0.916748 4.84288V0.916626H4.843V2.16663H2.16675V4.84288H0.916748ZM13.8413 4.84288V2.16663H11.1651V0.916626H15.0913V4.84288H13.8413Z",
		fill: "white"
	})
});
export default SvgFullscreen;
